// context/CartContext.jsx
import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config/config';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = async (product) => {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
         `${config.apiBaseUrl}/api/users/addtocart`,
        {
          productId: product.productId,
          productName: product.productName,
          price: product.price,
          quantity: 1,
        },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );

      
      await fetchCart(); // update cart after adding
    } catch (error) {
     
    }
  };

  const fetchCart = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('No token found, fetchCart aborted');
      return;
    }
   

    const response = await axios.get(`${config.apiBaseUrl}/api/users/cart`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    
    setCartItems(response.data || []);
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
};


  // 👉 Fetch cart when app loads
  useEffect(() => {
    fetchCart();
  }, []);

  return (
    <CartContext.Provider value={{ cartItems, addToCart, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};